import { DownloadOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Input,
  Menu,
  Row,
  Space,
  Table,
  Tooltip,
  Spin
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { font } from '../../Common/font';
import logo from '../../Images/logo.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchViewDieQuotationById } from '../../slices/die-quotation';
import PrintDieQuotation from '../Authentication/PrintDiequotation'
import html2pdf from 'html2pdf.js';
import { LoadingOutlined } from '@ant-design/icons';


const ViewDieQuotationList = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: currentUser } = useSelector(state => state.auth);
  const { data: settingData } = useSelector(state => state.setting);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [quotationData, setQuotationData] = useState(null);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const printRef = useRef();

  const handleDownloadPDF = () => {
    const element = printRef.current;
    if (!element) return;

    setLoadingPDF(true); // Show loader

    setTimeout(() => {
      const clone = element.cloneNode(true);
      clone.querySelectorAll('.no-print').forEach(el => el.remove());
      const style = document.createElement('style');
      style.innerHTML = `  body {
    font-size: 12px !important;
    margin: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .print-container {
    min-height: 1000px;
    position: relative !important;
    padding-bottom: 100px !important;
  }

  .page {
    page-break-after: always !important;
    position: relative !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .header-text {
    font-size: 12px !important;
    line-height: 1 !important;
  }

  .page-content {
    width: 100% !important;
    overflow: visible !important;
    font-size: 12px !important;

  }

  .signature-section {
     position: absolute !important;
    bottom: 10px !important;
    width: 100% !important;
    text-align: center !important;
    margin-top: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

.bankDetails {
  font-size: 12px;
  color: black;
  display: flex;
  flex-direction: column;
  float: right;
  gap: 4px;
  margin-top: 12px;
  line-height: 1.4;
}

  .ant-row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-bottom: 15px !important;
  }

  .col-sr       { width: 2.16% !important; }  /* SR */
  .col-inq      { width: 8.33% !important; }  /* Inq No */
  .col-profile  { width: 10.33% !important; }  /* Profile No */
  .col-desc     { width: 10.33% !important; }  /* DESCRIPTION */
  .col-alloy    { width: 6.33% !important; }  /* Alloy */
  .col-press    { width: 8.33% !important; }  /* Press */
  .col-uom      { width: 6.33% !important; }  /* UoM */
  .col-qty      { width: 8.5% !important; }  /* Qty */
  .col-basic    { width: 2.5% !important; }  /* Basic */
  .col-igst     { width: 5.33% !important; }  /* CGST */
  .col-total    { width: 4.16% !important; }  /* Total */


  
  .ant-col {
    box-sizing: border-box;
    padding: 1px !important;
  }

  h1, h2, h3, h4, h5 {
    color: rgb(2, 15, 28) !important;
    font-size: 12px !important;
    margin-bottom: 3px !important;
    margin-top: 0 !important;
  }

  .ant-table {
    width: 100% !important;
    font-size: 12px !important;
    table-layout: fixed !important;
    margin: 8px 0 !important;
  }

  .ant-table-container {
    overflow: visible !important;
    border: 1px solid #d9d9d9 !important;
    padding: 0px !important;
  }

  .ant-table-wrapper {
    padding: 0 !important;
    overflow: visible !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 1px 1px !important; 
    font-size: 9px !important;
    background-color: white !important;
    border: 1px solid #d9d9d9 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: break-word !important;
    line-height: 1.1 !important;
    height: auto !important;
    min-height: 20px !important;
  }

  .kind_attention {
    margin-right: 20px !important;
  }

  .ant-table-thead > tr > th {
    background-color: #12406a !important;
    color: white !important;
    font-weight: bold !important;
    text-align: center !important;
    font-size: 9px !important;
  }

  .ant-table-wrapper .ant-table-summary > tr > td {
    border: 1px solid #d9d9d9 !important;
    padding: 1px 1px !important;
    font-size: 9px !important;
  }

  .summary-cell-center {
    text-align: center !important;
  }

  .summary-cell-right {
    text-align: right !important;
    padding-right: 3px !important;
  }

  .ant-divider {
    margin: 5px 0 !important;
    border-top: 1px solid #d9d9d9 !important;
  }

  .no-print {
    display: none !important;
  }

  .terms-page {
    padding: 2px !important;
    margin: 0 !important;
    page-break-before: auto !important;
  }

  .terms-heading {
    font-size: 18px !important;
    margin-bottom: 2px !important;
  }

  .terms__content ul li{
     font-size: 10px !important;
  }

  .terms__content {
    font-size: 2px !important;
    text-align: justify !important;
    line-height: 1.14 !important;
    max-width: 98% !important;
    margin: 0 auto !important;
    padding: 1px 5px !important;
  }

  .terms__content h3 {
    font-weight: 600 !important;
    margin: 5px 0 !important;
    font-size: 14px !important;
  }

  img {
    max-width: 100% !important;
  }

  .customer-details {
    margin-bottom: 8px !important;
  }

  .customer-details-header {
    background-color: #12406a !important;
    color: white !important;
    padding: 2px 5px !important;
    font-weight: bold !important;
    margin-bottom: 2px !important;
    font-size: 9px !important;
  }

  .customer-details-content {
    padding: 3px 5px !important;
    border: 1px solid #d9d9d9 !important;
  }

  /* Remove horizontal scroll */
  * {
    overflow-x: visible !important;
  }

  /* Ensure table fits within page */
  .ant-table-scroll {
    overflow-x: visible !important;
  }

  /* Compact spacing */
  .ant-typography {
    margin-bottom: 0 !important;
  }

  /* Logo section */
  .logo-section img {
    max-width: 150px !important;
    height: auto !important;
    float: right !important;
  }`

      clone.appendChild(style);

      const opt = {
        margin: 0,
        filename: 'die Quotation.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

      html2pdf().set(opt).from(clone).save().then(() => {
        setLoadingPDF(false); // Hide loader after save
      });
    }, 300); // Small delay allows render of PrintQuotation
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchViewDieQuotationById({
            id: id
          }),
        ).unwrap();

        setQuotationData(response.data);
      } catch (error) {
        console.error('Failed to fetch quotation:', error);
      }
    };

    fetchData();
  }, [dispatch, id, page, pagesize, search, orderBy]);

 

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      render: (text, object, index) => { return index + 1 }
    },
    {
      title: 'Inq No.',
      dataIndex: 'inquiry_number',
      key: 'inquiry_number',
      render: (text, record) => {
        return <span>{record?.inquiry_number ? record?.inquiry_number : 'N/A'}</span>;
      },
    },
    {
      title: 'Section Number',
      dataIndex: 'die_number',
      key: 'die_number',
      render: (text, record) => {
        return <span>{record?.profile_no?.die_number ? record?.profile_no?.die_number : 'N/A'}</span>;
      },
    },
    {
      title: 'Profile Description',
      dataIndex: 'die_quotation_details',
      key: 'die_quotation_details',
      render: (text, record) => {
        const dimensions = [
          record?.profile_no?.dimension1,
          record?.profile_no?.dimension2,
          record?.profile_no?.dimension3,
          record?.profile_no?.dimension4,
        ]
          .filter(die => die !== null && die !== '' && die !== undefined)
          .map(die => Number(die).toFixed(2))
          .join(' x ');

        return <span>{dimensions ? `${dimensions} MM` : 'N/A'}</span>;
      },
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',

      render: record => {
        return <span>{record?.name || 'N/A'}</span>;
      },
    },
    {
      title: 'Press Capacity',
      dataIndex: 'press_capacity',
      key: 'press_capacity',

    },
    {
      title: 'Unit of Measure',
      dataIndex: 'unit_of_measurement',
      key: 'unit_of_measurement',

    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',

    },
    {
      title: 'Total Basic',
      dataIndex: 'profile_devlopment_cost',
      key: 'profile_devlopment_cost',

    },
    {
      title: 'CGST',
      key: 'cgst',
      render: record => {
        const cgst = record?.profile_devlopment_cost
          ? (record.profile_devlopment_cost * 9) / 100
          : 0;
        return <span>{cgst || 'N/A'}</span>;
      },
    },
    {
      title: 'SGST',
      key: 'sgst',
      render: record => {
        const sgst = record?.profile_devlopment_cost
          ? (record.profile_devlopment_cost * 9) / 100
          : 0;
        return <span>{sgst || 'N/A'}</span>;
      },
    },

    {
      title: 'Total Amount(Rs.)',
      key: 'total',
      render: record => {
        const basicAmount = record?.profile_devlopment_cost || 0;
        const sgst = (basicAmount * 9) / 100;
        const cgst = (basicAmount * 9) / 100;
        const totalAmount = basicAmount + sgst + cgst;

        return <span>{totalAmount.toFixed(2) || 'N/A'}</span>;
      },
    },
  ];
  const debounceTimeout = useRef(null);

  const handleSearch = e => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSearch(e.target.value);
      setPage(1);
    }, 100);
  }; 

  const handlePdfDownload = () => {
    const doc = new jsPDF('p', 'pt', 'a4');
    doc.addFileToVFS('WorkSans-normal.ttf', font);
    doc.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    doc.setFont('WorkSans');
    const pageHeight = doc.internal.pageSize.height;
    let y = 20;
    const imgUrl = logo; // Replace with your image
    const imgWidth = 181; // Adjust width as needed
    const imgHeight = 48; // Adjust height as needed
    const margin = 10;
    const imgX = doc.internal.pageSize.width - imgWidth - margin;
    const imgY = margin;

    doc.addImage(imgUrl, 'JPEG', imgX, imgY, imgWidth, imgHeight);
    y += 55;

    doc.setFontSize(22);
    doc.text('Die Quotation', doc.internal.pageSize.width / 2, y, {
      align: 'center',
    });
    y += 60;

    doc.setFontSize(12);

    let currentY = y;

    const leftFields = [
      { label: 'M/S.', value: '' },
      { label: '', value: `${quotationData?.customer?.customer_name}` || 'N/A' },
      { label: '', value: `${quotationData?.customer?.office_address?.shop}, ${quotationData?.customer?.office_address?.area}` || 'N/A' },
      { label: '', value: `${quotationData?.customer?.office_address?.landmark}, ${quotationData?.customer?.office_address?.area}` || 'N/A' },
      { label: '', value: `${quotationData?.customer?.office_address?.city}, ${quotationData?.customer?.office_address?.state} - ${quotationData?.customer?.office_address?.pin_code}` || 'N/A' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: 'Kind Attention', value: '' },
      { label: 'Name:', value: quotationData?.customer?.customer_contact_persons[0]?.contact_person_name || 'N/A' },
      { label: 'Mobile:', value: `+${quotationData?.customer?.customer_contact_persons[0]?.contact_person_mobile_number}` || 'N/A' }
    ];

    const rightFields = [
      { label: 'Date: ', value: dayjs(quotationData?.quotation_date).format('DD-MM-YYYY') },
      { label: 'Quotation No: ', value: quotationData?.die_quotation_no || 'N/A' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
    ];

    const lineHeight = 15;

    const leftFieldsX = 8;
    const rightFieldsX = doc.internal.pageSize.width / 2 + 50;

    let leftFieldsY = y;
    let rightFieldsY = y;

    leftFields.forEach(term => {
      const isSectionHeader = term.label.trim() === 'M/S.' || term.label.trim() === 'Kind Attention';

      if (isSectionHeader) {
        doc.setFillColor(2, 96, 187); // Blue background
        doc.setTextColor(255, 255, 255); // White text
        doc.rect(leftFieldsX - 2, leftFieldsY - 12, 120, lineHeight, 'F'); // 'F' = fill only
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, leftFieldsX, leftFieldsY);
        doc.setFont('WorkSans', 'normal');
        doc.setTextColor(0, 0, 0);
      } else if (term.label.trim()) {
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, leftFieldsX, leftFieldsY);
        doc.setFont('WorkSans', 'normal');
        doc.text(term.value, leftFieldsX + 50, leftFieldsY);
      } else {
        doc.setFont('WorkSans', 'normal');
        doc.text(term.value, leftFieldsX, leftFieldsY);
      }

      leftFieldsY += 15;

    });

    currentY = y;
    const rightColX = doc.internal.pageSize.width / 2 + 30;

    rightFields.forEach(field => {
      if (field.label === 'Kind Attention') {
        doc.setFont('WorkSans', 'bold');
        doc.setFillColor(2, 96, 187); // Black background
        doc.setTextColor(255, 255, 255);
        doc.rect(570, currentY - 12, 200, 17, 'F'); // Adjust width/height as needed
      } else {
        doc.setFont('WorkSans', 'normal');
        doc.setTextColor(0, 0, 0);
      }
      doc.text(field.label, rightColX, currentY);
      doc.text(field.value, rightColX + 90, currentY);
      currentY += lineHeight;
    });

    y = currentY + 70;
    const pdfColumns = ['Sr. No.'];
    const mappedColumns = [(item, index) => index + 1];

    const bodyRows = quotationData?.die_quotation_details.map((item, index) => {
      return [
        index + 1,
        item?.inquiry_number,
        item?.profile_no?.die_number || '',
        `${item.profile_no?.dimension1 || ''} MM` +
        (item.profile_no?.dimension2 ? ` X ${item.profile_no?.dimension2} MM` : '') +
        (item.profile_no?.dimension3 ? ` X ${item.profile_no?.dimension3} MM` : ''),
        `${item?.alloy?.name || ''}`,
        item?.press_capacity,
        item?.unit_of_measurement,
        item?.quantity,
        item?.profile_devlopment_cost,
        item?.gst_amount,
        item?.gst_amount,
        item?.total_amount,
      ];
    });
    bodyRows.push([
      { content: 'Total :', colSpan: 7, styles: { halign: 'center', fontStyle: 'bold' } },
      { content: quotationData?.summary?.total_quantity, styles: { fontStyle: 'bold' } },
      { content: quotationData?.summary?.total_basic_amount, styles: { fontStyle: 'bold' } },
      { content: quotationData?.summary?.total_gst_amount, styles: { fontStyle: 'bold' } },
      { content: quotationData?.summary?.total_gst_amount, styles: { fontStyle: 'bold' } },
      { content: quotationData?.summary?.total_amount_with_gst, styles: { fontStyle: 'bold' } },
    ]);
    const tableResult = doc.autoTable({
      head: [
        [
          { content: 'SR NO.', rowSpan: 2 },
          { content: 'Inq. NO.', rowSpan: 2 },
          { content: 'Profile No.', rowSpan: 2 },
          { content: 'Profile Description', rowSpan: 2 },
          { content: 'Alloy', rowSpan: 2 },
          { content: 'Press Capacity', rowSpan: 2 },
          { content: 'Unit of Measure', rowSpan: 2 },
          { content: 'Quantity', rowSpan: 2 },
          { content: 'TOTAL BASIC AMOUNT(Rs.)', rowSpan: 2 },
          { content: 'GST(Rs.)', colSpan: 2, styles: { halign: 'center' } },
          { content: 'TOTAL(Rs.)', rowSpan: 2 }
        ],
        [
          { content: 'SGST (9%)' },
          { content: 'CGST (9%)' }
        ]
      ],
      body: bodyRows,
      startY: y,
      theme: 'grid',
      pageBreak: 'auto',
      styles: {
        fontSize: 10,
        fontStyle: 'normal',
        cellPadding: { top: 10, bottom: 10, left: 10, right: 10 },
        lineWidth: 0.9,
        valign: 'middle',
        halign: 'center',
      },
      headStyles: {
        fillColor: [2, 96, 187],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      didParseCell: function (data) {
        if (data.cell.raw !== null && !isNaN(data.cell.raw) && data.cell.raw !== '') {
          data.cell.styles.halign = 'center';
        }
      },
      margin: { left: 10, right: 10 },
      didDrawPage: data => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(8);
        doc.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          doc.internal.pageSize.width - 80,
          doc.internal.pageSize.height - 10,
        );
      },
    });
    let finalY = tableResult.lastAutoTable.finalY;
    const remainingSpace = doc.internal.pageSize.height - finalY;
    if (remainingSpace < 200) { // Less space? Add new page
      doc.addPage();
      finalY = 20;
    }
    doc.setFontSize(12);
    doc.setFont("WorkSans", "bold");

    doc.setFillColor(2, 96, 187); // Black background
    doc.rect(417, finalY + 12, 159, 17, 'F'); // Adjust width/height as needed
    doc.setTextColor(255, 255, 255); // White text
    doc.text('Bank Details', 417, finalY + 22);
    y = finalY + 40;

    doc.setTextColor(0, 0, 0);
    const terms = [
    ];

    const bank_details = [
      { label: 'GST No:', value: `${quotationData?.customer?.gstin_number || 'N/A'}` },
      { label: 'Bank Name:', value: `${quotationData?.customer?.customer_banking_details[0]?.bank_name || 'N/A'}` },
      { label: 'Branch:', value: `${quotationData?.customer?.customer_banking_details[0]?.bank_branch_address || 'N/A'}` },
      { label: 'A/C No:', value: `${quotationData?.customer?.customer_banking_details[0]?.bank_account_number || 'N/A'}` },
      { label: 'IFSC Code:', value: `${quotationData?.customer?.customer_banking_details[0]?.bank_ifsc_code || 'N/A'}` },
    ];

    doc.setFontSize(10);

    const termsX = 8;
    const bankX = doc.internal.pageSize.width / 2 + 120;

    let termsY = y;
    let bankY = y;

    terms.forEach(term => {
      if (term.label.trim()) {
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, termsX, termsY);
        doc.setFont('WorkSans', 'normal');
        if (term.label === 'Duties Taxes & other Government levies :') {
          doc.text(term.value, termsX + 190, termsY);
        } else if (term.label === 'Minimum Order Quantity:') {
          doc.text(term.value, termsX + 120, termsY);
        } else {
          doc.text(term.value, termsX + 90, termsY);
        }
      } else {
        doc.text(term.value, termsX, termsY);
      }
      termsY += 15;
    });

    bank_details.forEach(field => {
      doc.setFont('WorkSans', 'bold');
      doc.text(field.label, bankX, bankY);
      doc.setFont('WorkSans', 'normal');
      doc.text(field.value, bankX + 60, bankY);
      bankY += 15;
    });
    y += 220;
    const spaceNeededForFooter = 20; // Adjust depending on your footer height
    const lastY = Math.max(termsY, bankY);
    if (lastY + spaceNeededForFooter > pageHeight) {
      doc.addPage();
      y = 40; // Reset y for new page
    } else {
      y = lastY + 20; // Some spacing before footer
    }
    let lastTermsConsitionPositon = 0;
    if (quotationData?.terms_and_condition) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = quotationData.terms_and_condition;

      let termsY = y;
      doc.setFontSize(14);
      doc.setFont('WorkSans', 'bold');
      doc.text('Terms and Conditions', doc.internal.pageSize.width / 2, termsY, {
        align: 'center',
      });
      termsY += 30;
      const processNode = (node, level = 0, indent = 0) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (!text) return termsY;
        }

        const textMargin = 10 + indent;
        const maxWidth = doc.internal.pageSize.width - (textMargin * 2);
        if (termsY > doc.internal.pageSize.height - 40) {
          doc.addPage();
          termsY = 40;
          lastTermsConsitionPositon = termsY;
        }
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text) {
            doc.setFont('WorkSans', 'normal');
            doc.setFontSize(9);
            const lines = doc.splitTextToSize(text, doc.internal.pageSize.width - 80);
            doc.text(lines, textMargin, termsY);
            termsY += (lines.length * 10) + 5;
            lastTermsConsitionPositon = termsY;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          switch (node.tagName.toLowerCase()) {
            case 'h3':
              doc.setFont('WorkSans', 'bold');
              doc.setFontSize(11);
              const titleText = node.textContent.trim();
              doc.text(titleText, textMargin, termsY);
              termsY += 15;
              lastTermsConsitionPositon = termsY;
              break;

            case 'p':
              if (node.textContent.trim()) {
                doc.setFont('WorkSans', 'normal');
                doc.setFontSize(9);
                const paragraphText = node.textContent.trim();
                const lines = doc.splitTextToSize(paragraphText, doc.internal.pageSize.width - 80);
                doc.text(lines, textMargin, termsY);
                termsY += (lines.length * 10) + 10;
                lastTermsConsitionPositon = termsY;
              }
              break;

            case 'ul':
              termsY += 5;
              for (const child of node.children) {
                if (child.tagName.toLowerCase() === 'li') {
                  const bulletPoint = '• ';
                  doc.setFont('WorkSans', 'normal');
                  doc.setFontSize(9);

                  const bulletWidth = doc.getStringUnitWidth(bulletPoint) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                  doc.text(bulletPoint, textMargin, termsY);

                  const itemText = child.textContent.trim();
                  const itemLines = doc.splitTextToSize(itemText, doc.internal.pageSize.width - 90 - bulletWidth);
                  doc.text(itemLines, textMargin + bulletWidth, termsY);
                  termsY += (itemLines.length * 10) + 5;
                  if (termsY > doc.internal.pageSize.height - 40) {
                    doc.addPage();
                    termsY = 40;
                    lastTermsConsitionPositon = termsY;
                  }
                }
              }
              termsY += 5;
              break;

            default:
              for (const child of node.childNodes) {
                processNode(child, level + 1, indent);
              }
          }
        }

        return termsY;
      };
      for (const child of tempDiv.childNodes) {
        processNode(child);
      }
    }
    doc.setFontSize(10);
    doc.setFont('WorkSans', 'bold');
    doc.text('Prepared By', 90, lastTermsConsitionPositon + 40, { align: 'right' });

    doc.text('Authorised Signatory', doc.internal.pageSize.width - 200, lastTermsConsitionPositon + 40, { align: 'left' });
    doc.text((settingData?.company_settings?.company_name), doc.internal.pageSize.width - 220, lastTermsConsitionPositon + 50, { align: 'left' });
    y += 20;

    /* Last Footer Row */
    const latPageHeight = doc.internal.pageSize.height;
    const footerY = latPageHeight - 20;

    const footerAddress = '110, Ganesh glory, Godrej garden City road, jagatpur Ahmedabad - 382481';
    const footerContact = 'info@aluxerp.com | www.aluxerp.com';

    const pageWidth = doc.internal.pageSize.width;
    const footerY2 = footerY + 9;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(footerAddress, pageWidth / 2, footerY, { align: 'center' });

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(footerContact, pageWidth / 2, footerY2, { align: 'center' });

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(20, footerY - 10, pageWidth - 20, footerY - 10);

    doc.save(`DieQuotation_${quotationData?.die_quotation_no || 'N/A'}.pdf`);

  };

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'inquiry_number',
    'die_number',
    'die_quotation_details',
    'alloy',
    'press_capacity',
    'unit_of_measurement',
    'quantity',
    'profile_devlopment_cost',
    'total',
    'created_at',
    'created_by',
    'updated_at',
    'updated_by',
    'action',
    'sgst',
    'cgst',
  ]);
  const dynamicColumns = (() => {
    let cols = columns.filter(col => {
      const key = col.dataIndex || col.key;
      return checkedList.includes(key) && key !== 'sgst' && key !== 'cgst' && key !== 'total';
    });
    if (checkedList.includes('sgst') && checkedList.includes('cgst')) {
      cols.push({
        title: 'GST',
        children: [
          {
            title: 'CGST (18%)',
            key: 'cgst',
            render: record => {
              const cgst = record?.profile_devlopment_cost
                ? (record.profile_devlopment_cost * 18) / 100
                : 0;
              return <span>{cgst.toFixed(2)}</span>;
            },
          },
        ],
      });
    } else {
      if (checkedList.includes('sgst')) {
        cols.push({
          title: 'SGST (9%)',
          key: 'sgst',
          render: record => {
            const sgst = record?.profile_devlopment_cost
              ? (record.profile_devlopment_cost * 9) / 100
              : 0;
            return <span>{sgst.toFixed(2)}</span>;
          },
        });
      }
      if (checkedList.includes('cgst')) {
        cols.push({
          title: 'CGST (9%)',
          key: 'cgst',
          render: record => {
            const cgst = record?.profile_devlopment_cost
              ? (record.profile_devlopment_cost * 9) / 100
              : 0;
            return <span>{cgst.toFixed(2)}</span>;
          },
        });
      }
    }
    cols.push({
      title: 'Total Amount(Rs.)',
      key: 'total',
      render: record => {
        const basicAmount = record?.profile_devlopment_cost || 0;
        const tax = (basicAmount * 18) / 100;
        const total = basicAmount + tax;
        return <span>{total.toFixed(2)}</span>;
      },
    });

    return cols;
  })();
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={checkedValues => {
            handleColumnVisibilityChange(checkedValues);
          }}
        >
          <Row gutter={16}>
            <Col xs={12} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr.No.
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="inquiry_number">
                Inquiry Number
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="die_number">
                Section Number
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="die_quotation_details">
                Profile Description
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="alloy">Alloy</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="press_capacity">Press Capacity</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="unit_of_measurement">Unit of Measure</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="quantity">Quantity</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="profile_devlopment_cost">Total Basic</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="cgst">CGST</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="sgst">SGST</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="total">Total Amount</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );


  const resetFilter = () => {
    setSearch('');
    setOrderBy('');
    setPage(1);
  };

  return (
    <>
      {loadingPDF && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#12406a' }} spin />}
            tip="Generating PDF..."
          />
        </div>
      )}
      <div>
        <div className="sticyaction">
          <Row className="pagenamerow" justify="space-between" align="middle">
            <Col>
              <h2 style={{ margin: 0 }}>View Die Quotation</h2>
              <div className="bredcrumbwrp">
                <Link to="/die-quotation-list" className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/die-quotation-list">Die Quotations</Link> },
                    { title: 'View Die Quotation' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              {currentUser.permissions.permissions.die_quotation.includes(
                'change_diequotation',
              ) && (
                  <Button type="primary"

                    style={{
                      marginBottom: '20px',
                      float: 'center',
                      marginRight: '10px',
                    }}
                    icon={<EditOutlined />}
                    onClick={() => navigate(`/edit-die-quotation/${quotationData?.id}`)}
                  >
                    Edit Die Quotation
                  </Button>
                )}
              {currentUser.permissions.permissions.die_quotation.includes(
                'print_die_quotation_pdf_copy',
              ) && (
                  <>
                    <Tooltip placement="top" title={'Download PDF'}>
                      <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        style={{ marginBottom: '20px', float: 'right' }}
                        onClick={handleDownloadPDF}
                      >
                        Download PDF
                      </Button>
                    </Tooltip>
                    <div style={{ display: 'none' }}>
                      <div ref={printRef} style={{ width: '800px' }}>
                        <PrintDieQuotation />
                      </div>
                    </div>
                  </>
                )}
            </Col>
          </Row>
        </div>
        <div className='px-4'
          style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}
        >
          <Row gutter={[16, 16]} className="viewform">
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Number</label>
              <div className="customvalue">{quotationData?.die_quotation_no || 'N/A'}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Date</label>
              <div className="customvalue">
                {quotationData?.quotation_date ? dayjs(quotationData.quotation_date).format('DD-MM-YYYY') : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Customer Name</label>
              <div className="customvalue">{quotationData?.customer?.customer_name}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Die Right</label>
              <div className="customvalue">{quotationData?.die_right === 'Own' ? settingData?.company_settings?.company_name : quotationData?.die_right}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Minimum Order Qty (Kg)</label>
              <div className="customvalue">{quotationData?.minimum_order_qty}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Sample Delivery</label>
              <div className="customvalue">{quotationData?.sample_delivery}</div>
            </Col>
          </Row>

          <Divider />

          <div className="flex justify-between gridtitle">
            <h3>Die Quotation Item List</h3>
            <Space size="small">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />

              <Tooltip placement="top" title="Reset Filter">
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </Space>
          </div>

          <Table
            className='px-0'
            rowKey="id"
            dataSource={quotationData?.die_quotation_details}
            columns={dynamicColumns}
            pagination={false}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ViewDieQuotationList;
